import React, {
	Component
} from 'react';
import Global from '../../Global';
import './Subtitle.css'

class Subtitle extends Component {

	constructor(props) {
		super(props);

		this.state = {
			data: {
				items: null
			}
		}
	}

	componentDidMount() {
		var url = Global.getAPI(this.props.urlAPI);
		fetch(url)
			.then(function (response) {
				if (response.status >= 400) {
					throw new Error('Error API: Subtitle');
				}
				return response.json();
			})
			.then(data => this.setState({
				data
			}));
	}
	
	getSubtitleItem(){
		let html;
		/* if(this.state.data.items.length > 2){
			html = this.state.data.topNavMenu.items[1].items.map( ( item, index ) =>
				index != 0 ? 
					(<div key={index} className={"subtitle-item "+ (item.id === '3' ? "active" : "")}>
					  <a href={item.href} className="subtitle-text"><span className="">{item.label}</span></a>
					</div>)
				: "" 
			);
		}else{
			html = "";
		} */
		html = this.state.data.items.map( ( item, index ) =>
			(<div key={index} className={"subtitle-item "+ (item.selected === 'true' ? "active" : "")}>
				<a href={item.href} className="subtitle-text"><span className="">{item.label}</span></a>
			</div>)
		);
		return html
	}

	render() {
		if (this.state.data.items) {
			return (
				<div className="subtitle-div">
					{ this.getSubtitleItem() }
				</div>
			)
		} else {
			return null;
		}

	}

}


export default Subtitle;